import { CLEAR_NOTIFICATION } from '../types';

export default () => ({
  type: CLEAR_NOTIFICATION,
});
